import type { UserModule, UserModulesResponse } from "@repo/types";
import { apiClient } from "./base/http";

const normalizeRoutePaths = (routePaths: UserModule["route_paths"]): string[] => {
  if (Array.isArray(routePaths)) {
    return routePaths;
  }

  if (typeof routePaths === "string" && routePaths.length > 0) {
    try {
      const parsed = JSON.parse(routePaths) as unknown;
      if (Array.isArray(parsed) && parsed.every((item) => typeof item === "string")) {
        return parsed as string[];
      }
    } catch {
      // Ignore parse errors and fall back to wrapping the string as a single path.
    }
    return [routePaths];
  }

  return [];
};

export type NormalizedUserModule = UserModule & { route_paths: string[] };

export const fetchUserModules = async (): Promise<NormalizedUserModule[]> => {
  const { data } = await apiClient.get<UserModulesResponse>("/api/auth/user/modules");
  if (!data.success) {
    throw new Error("無法取得用戶模組資訊");
  }

  return (data.modules ?? []).map((module) => ({
    ...module,
    route_paths: normalizeRoutePaths(module.route_paths)
  }));
};
